export default __webpack_public_path__ + "static/media/Omb02.21dbf8f9.png";